import { AbstractControl, ValidationErrors } from '@angular/forms';
export class NospaceValidator {
    static blockSpace(control: AbstractControl): ValidationErrors | null {
        return control.value && control.value.startsWith(" ") ? {blockSpace: true} : null;
    }
}